const openModal = (modal) => {
  if (!modal) return;
  const foundModal = typeof modal === 'string' ? document.querySelector(modal) : modal;
  if (!foundModal) return;

  foundModal.style.display = 'block';
  document.querySelector('html').style.overflow = 'hidden';
  setTimeout(() => {
    window.requestAnimationFrame(() => {
      foundModal.classList.add('open');
      foundModal.style.display = '';
      if (foundModal.getAttribute('tabindex')) foundModal.focus();
    });
  }, 100);
};

const closeModal = (modal) => {
  if (!modal) return;
  const foundModal = typeof modal === 'string' ? document.querySelector(modal) : modal;
  if (!foundModal) return;

  const transitionDuration = parseFloat(getComputedStyle(foundModal).transitionDuration.replace('s', '')) * 1000;
  foundModal.style.display = 'block';
  window.requestAnimationFrame(() => {
    foundModal.classList.remove('open');
    setTimeout(() => {
      foundModal.style.display = '';
      document.querySelector('html').style.overflow = '';
    }, transitionDuration);
  });
};

const initModals = (root = document) => {
  if (!root) return;
  const rootEl = typeof root === 'string' ? document.querySelector(root) : root;
  if (!rootEl) return;

  document.querySelectorAll('.modal').forEach((modal) => {
    modal
      .querySelectorAll('.modal__backdrop , .modal__close')
      .forEach((closer) => closer.addEventListener('click', () => closeModal(modal)));
    if (modal.getAttribute('tabindex'))
      modal.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') closeModal(modal);
      });
    if (modal.id)
      rootEl.querySelectorAll(`a[href*="${modal.id}"]`).forEach((btn) =>
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          openModal(modal);
        }),
      );
  });
};

export { initModals, openModal, closeModal };
